/**
 * Menus opened from the sidebar — the organisation and profile dropdowns and
 * the project picker — set their rows like the nav rows beside them: the same
 * 0.75rem medium type on the same 1.875rem pitch (SidebarNavItem). Applied to
 * the menu's content element rather than to each item, so the shared menu and
 * command primitives keep their defaults everywhere else. Covers Radix menu
 * items and cmdk items alike.
 */
export const SIDEBAR_MENU_ROWS = [
  "[&_[role=menuitem]]:h-[1.875rem] [&_[role=menuitem]]:py-0 [&_[role=menuitem]]:text-[0.75rem] [&_[role=menuitem]]:font-medium",
  "[&_[cmdk-item]]:h-[1.875rem] [&_[cmdk-item]]:py-0 [&_[cmdk-item]]:text-[0.75rem] [&_[cmdk-item]]:font-medium",
].join(" ");
